import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const RoleBasedRoute = props => {
	const [returnedRoute, setReturnedRoute] = useState("");

	useEffect(() => {
		props.permissionLevel.map(role => {
			props.roles.includes(role) && setReturnedRoute(<Route {...props} />)
		})
	}, [props, props.roles]);

	return <>{returnedRoute}</>;
};

const mapStateToProps = state => ({
	roles: [state?.auth?.user?.role] || []
});

export default connect(mapStateToProps, null)(RoleBasedRoute);
